import React from "react";
import "../css/Home4.css";

const Home4 = () => {
  return (
    <div className="home4">

      {/* ================= HERO — GIANT LANDING BANNER ================= */}
      <section className="h4-hero-banner">

        {/* Left text */}
        <div className="h4-hero-content">
          <h1>
            Welcome to <span>SHANK</span><br />
            Where Fitness <span>Feels Fun</span>
          </h1>

          <p>
            A bright and energetic space built for playful workouts,
            effortless progress, and positive energy.
          </p>

          <div className="h4-hero-actions">
            <button className="h4-primary-big">Start Your Glow-Up</button>
            <button className="h4-secondary-big">Browse Classes</button>
          </div>
        </div>

        {/* Right floating image */}
        <div className="h4-hero-img-block">
          <div className="hero-circle c1"></div>
          <div className="hero-circle c2"></div>

          <img
            src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg"
            alt="hero athlete"
          />
        </div>
      </section>



      {/* ================= CURVED TRANSITION ================= */}
      <div className="h4-curve-divider"></div>



      {/* ================= BENTO PLAY GRID ================= */}
      <section className="h4-bento-new">

        <div className="bento-new-item one">
          <h2>Fun Classes</h2>
          <p>Workouts packed with energy & rhythm</p>
        </div>

        <div className="bento-new-item img-big">
          <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" alt="" />
        </div>

        <div className="bento-new-item two">
          <h2>Real Progress</h2>
          <p>Small steps → Big transformation</p>
        </div>

        <div className="bento-new-item img-tall">
          <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="" />
        </div>

        <div className="bento-new-item three">
          <h2>Nutrition Hacks</h2>
          <p>Eat bright. Stay bright.</p>
        </div>

      </section>



      {/* ================= FUN STATS ================= */}
      <section className="h4-fun-stats">
        <div>
          <h1>1200+</h1>
          <p>Members glowing daily</p>
        </div>
        <div>
          <h1>45+</h1>
          <p>Unique energizing classes</p>
        </div>
        <div>
          <h1>08</h1>
          <p>Playful expert trainers</p>
        </div>
      </section>



      {/* ================= ZIGZAG INFO STRIPS ================= */}
      <section className="h4-zigzag">
        <div className="zz-block left">
          <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="" />
          <div>
            <h2>Move With Joy</h2>
            <p>Every session is designed to boost mood and confidence.</p>
          </div>
        </div>

        <div className="zz-block right">
          <div>
            <h2>Made For Real People</h2>
            <p>No pressure, no ego—just a community that lifts each other up.</p>
          </div>
          <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="" />
        </div>
      </section>



      {/* ================= FUN FLOAT MOSAIC ================= */}
      <section className="h4-mosaic-float">
        <h2 className="mf-title">Shank Moments</h2>

        <div className="mf-grid">
          <div className="mf-item tall">
            <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" />
          </div>
          <div className="mf-item wide">
            <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" />
          </div>
          <div className="mf-item">
            <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" />
          </div>
          <div className="mf-item">
            <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" />
          </div>
        </div>
      </section>



      {/* ================= CLEAN CURVED CTA ================= */}
      <section className="h4-cta-clean">
        <div className="cta-clean-inner">
          <h2>Become Part of the SHANK Fam</h2>
          <p>
            A fun, bright, supportive place to move, grow, and glow.
          </p>
      
          <button className="cta-clean-btn">Join the Community</button>
        </div>
      </section>


    </div>
  );
};

export default Home4;
